export default __webpack_public_path__ + "static/media/b.172b859d.png";